module.exports = __webpack_public_path__ + "static/media/house.b2edff86.png";